<template>
  <div class="people-editor">
    <el-form ref="form" label-width="100px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="头像">
        <img class="img" :src="currentItem.headimg" title="更换图片" @click="select">
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-model="currentItem.name" placeholder="名称" style="width:300px"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="currentItem.describe" :autosize="{ minRows: 2, maxRows: 8}" placeholder="描述" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <upload-img ref="upload"></upload-img>
  </div>
</template>
<script>
import UploadImg from '@/components/UploadImg'
export default {
  name: 'peopleEditor',
  components: {
    UploadImg
  },
  data () {
    return {
      articles: []
    }
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  methods: {
    select () {
      this.$refs.upload.show([this.currentItem.headimg], 'thumb', 1).then(res => {
        if (res.length) {
          this.currentItem.headimg = res[0]
        }
      }).catch()
    }
  }
}
</script>
<style lang="less" scoped>
.people-editor {
  .img {
    width: 70px;
    height: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/peopleEditor.vue